<template>
  <div class="mk-autoweb-module mk-autoweb-module-product-trial">
    <p class="mk-autoweb-module-title">{{ element.titleBarName }}</p>
    <span class="mk-autoweb-module-subtitle">{{ element.titleBarDesc }}</span>
    <div class="role-container">
      <div
        class="roleItem goyonbiptiyan"
        v-for="(item, index) in childItem.propsValue.data"
        :key="index"
      >
        <img :src="item.customField1" alt />
        <p>{{ item.customField2.text }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { buttonObject } from "@/modules/autoweb/config/elementObject.js";
export default {
  name: "MkProductTrialWeb",
  props: {
    element: {
      type: Object,
      default: () => {
        return {};
      }
    },
    childItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      max: 6,
      min: 4,
      fields: [
        {
          code: "customField1",
          label: "头像",
          type: "image",
          width: 280,
          height: 170
        },
        {
          code: "customField2",
          label: "角色",
          type: "button"
        }
      ],
      data: [
        {
          customField1:
            "https://mks.yybip.com/group1/M00/0A/E2/CgoRC2c9VgqAeadKAABriIFP6Os780.png",
          customField2: _.merge(_.cloneDeep(buttonObject), {
            text: "CEO",
            beforeClick: {
              type: 1,
              form: "668605a22f1c5d0008dc531c", 
              formtime: "七天"
            },
            afterClick: {
              type: 4,
              contentId: "BIPCEO"
            }
          })
        },
        {
          customField1:
            "https://mks.yybip.com/group1/M00/0A/E2/CgoRC2c9Vh6Ae1zgAABrzlopwHE971.png",
          customField2: _.merge(_.cloneDeep(buttonObject), {
            text: "财务主管",
            beforeClick: {
              type: 1,
              form: "668605a22f1c5d0008dc531c",
              formtime: "七天"
            },
            afterClick: {
              type: 4,
              contentId: "BIPCWZG2"
            }
          })
        },
        {
          customField1:
            "https://mks.yybip.com/group1/M00/03/32/CgoRDGc9Vi2ASn8MAABft428ZPc564.png",
          customField2: _.merge(_.cloneDeep(buttonObject), {
            text: "人事主管",
            beforeClick: {
              type: 1,
              form: "668605a22f1c5d0008dc531c",
              formtime: "七天"
            },
            afterClick: {
              type: 4,
              contentId: "BIPRSZG"
            }
          })
        },
        {
          customField1:
            "https://mks.yybip.com/group1/M00/0A/E2/CgoRC2c9VkCAXvH8AACgx-eD7CA681.png",
          customField2: _.merge(_.cloneDeep(buttonObject), {
            text: "供应链主管",
            beforeClick: {
              type: 1,
              form: "668605a22f1c5d0008dc531c",
              formtime: "七天"
            },
            afterClick: {
              type: 4,
              contentId: "BIPGYLZG"
            }
          })
        },
        {
          customField1:
            "https://mks.yybip.com/group1/M00/0A/E2/CgoRC2c9VlKAZa6wAABgwgqdqUc142.png",
          customField2: _.merge(_.cloneDeep(buttonObject), {
            text: "生产制造主管",
            beforeClick: {
              type: 1,
              form: "668605a22f1c5d0008dc531c",
              formtime: "七天"
            },
            afterClick: {
              type: 4,
              contentId: "BIPSCZG"
            }
          })
        },
        {
          customField1:
            "https://mks.yybip.com/group1/M00/03/32/CgoRDGc9VmSARui_AABkjlcE16A812.png",
          customField2: _.merge(_.cloneDeep(buttonObject), {
            text: "营销主管",
            beforeClick: {
              type: 1,
              form: "668605a22f1c5d0008dc531c",
              formtime: "七天"
            },
            afterClick: {
              type: 4,
              contentId: "BIPYXZG"
            }
          })
        }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
.mk-autoweb-module-product-trial .role-container {
  width: 880px;
  display: flex;
  justify-content: space-between;
  margin: 0.2rem auto 0.6rem;
  text-align: center;
}

.mk-autoweb-module-product-trial .role-container .roleItem {
  cursor: pointer;
  transition: all 0.4s;
}

.mk-autoweb-module-product-trial .role-container .roleItem:hover {
  transform: scale(1.1);
  border-radius: 0.03rem;
}
</style>
